import storage from 'good-storage'
const TOKEN_KEY = 'wd__key__'
const SECRET = 'wd_secret'
const PHONE = 'wd__phone__'
const USERID = 'wd__userid__'

export function saveKey (value) {
  storage.set(TOKEN_KEY, value)
  return value
}

export function getKey () {
  return storage.get(TOKEN_KEY, null)
  // return '~a8bbc8bb9wahqb'
}

export function savePhone (value) {
  storage.set(PHONE, value)
  return value
}

export function getPhone () {
  return storage.get(PHONE, null)
}

export function saveUserId (value) {
  storage.set(USERID, value)
  return value
}

export function getUserId () {
  return storage.get(USERID, null)
}

export function saveSecret (value) {
  storage.set(SECRET, value)
  return value
}

export function getSecret () {
  return storage.get(SECRET, null)
}
